import { Navbar, NavbarBrand, Nav, NavItem, Button, Row, Col, Container } from "reactstrap";
import { FaPhone } from "react-icons/fa";

const Header = ({ organization, handleCancel, showBanner = true }) => {
  return (
    <Container fluid className="p-0">
      <Navbar color="dark" dark expand="sm">
        <Container>
          <Row className="w-100 align-items-center p-0">
            {/* Left Column - Logo */}
            <Col xs={4} sm={2} className="d-flex justify-content-start">
              <NavbarBrand href="/" className="p-0 m-0" onClick={handleCancel}>
                <span className="d-sm-none text-white fw-semibold small">
                  {organization?.name}
                </span>
                <img
                  src={organization?.logo_url}
                  alt={organization?.name}
                  className="logo img-fluid d-none d-sm-block"
                  style={{ height: "clamp(44px, 9vw, 72px)", width: "auto" }}
                />
              </NavbarBrand>
            </Col>

            {/* Right Column - Call Button */}
            <Col xs={8} sm={10} className="d-flex justify-content-end p-0">
              <Nav navbar>
                <NavItem>
                  <Button
                    color="light"
                    href={'tel:' + organization?.phone_number}
                    className="d-flex align-items-center gap-1 gap-sm-2 py-1 py-sm-2 px-2 px-sm-3"
                    style={{ fontSize: "clamp(0.8rem, 2.8vw, 1rem)" }}
                  >
                    <FaPhone size={14} />
                    <span>{organization?.phone_number}</span>
                  </Button>
                </NavItem>
              </Nav>
            </Col>
          </Row>
        </Container>
      </Navbar>

      {/* Hero Image */}
      {showBanner && (
        <Row className="w-100 m-0">
          <Col className="p-0 hero-image">
            <img src="/img/header.png" alt="Golf Course" className="img-fluid w-100" style={{ objectFit: "cover", maxHeight: "400px" }} />
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default Header;
